import React from 'react';
import IconButton from '@mui/material/IconButton';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SendToMobileIcon from '@mui/icons-material/SendToMobile';
import WarningIcon from '@mui/icons-material/Warning';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MenuIcon from '@mui/icons-material/Menu';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import LogoutIcon from '@mui/icons-material/Logout';
import LockIcon from '@mui/icons-material/Lock';
import OutputIcon from '@mui/icons-material/Output';
import HelpIcon from '@mui/icons-material/Help';
import CloseIcon from '@mui/icons-material/Close';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import PhonelinkEraseIcon from '@mui/icons-material/PhonelinkErase';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import ResetTvIcon from '@mui/icons-material/ResetTv';
import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import PaletteIcon from '@mui/icons-material/Palette';
import StarSharpIcon from '@mui/icons-material/StarSharp';
import ArrowLeftSharpIcon from '@mui/icons-material/ArrowLeftSharp';
import ArrowRightSharpIcon from '@mui/icons-material/ArrowRightSharp';
import LocationOnSharpIcon from '@mui/icons-material/LocationOnSharp';
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import LoginIcon from '@mui/icons-material/Login';
import BadgeIcon from '@mui/icons-material/Badge';
import { CircularProgress } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import EmailIcon from '@mui/icons-material/Email';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import ImageIcon from '@mui/icons-material/Image';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import LockResetIcon from '@mui/icons-material/LockReset';
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
import TodayIcon from '@mui/icons-material/Today';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import ConstructionIcon from '@mui/icons-material/Construction';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import BusinessIcon from '@mui/icons-material/Business';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import DevicesFoldIcon from '@mui/icons-material/DevicesFold';
import SendTimeExtensionIcon from '@mui/icons-material/SendTimeExtension';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import PreviewIcon from '@mui/icons-material/Preview';
import EuroIcon from '@mui/icons-material/Euro';
import FreeCancellationIcon from '@mui/icons-material/FreeCancellation';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import SendIcon from '@mui/icons-material/Send';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SettingsIcon from '@mui/icons-material/Settings';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import EditRoadIcon from '@mui/icons-material/EditRoad';
import RemoveRoadIcon from '@mui/icons-material/RemoveRoad';
import TableChartIcon from '@mui/icons-material/TableChart';
import EventIcon from '@mui/icons-material/Event';
import SmartButtonIcon from '@mui/icons-material/SmartButton';
import EditNoteIcon from '@mui/icons-material/EditNote';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import PublicIcon from '@mui/icons-material/Public';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonIcon from '@mui/icons-material/Person';
import ScaleIcon from '@mui/icons-material/Scale';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

const iconMap = {
    addCircle: AddCircleIcon,
    deleteForever: DeleteForeverIcon,
    calendarMonth: CalendarMonthIcon,
    settingsBackupRestore: SettingsBackupRestoreIcon,
    arrowForward: ArrowForwardIcon,
    arrowBack: ArrowBackIcon,
    sendToMobile: SendToMobileIcon,
    warning: WarningIcon,
    eventRepeat: EventRepeatIcon,
    accessTime: AccessTimeIcon,
    edit: EditIcon,
    delete: DeleteIcon,
    menu: MenuIcon,
    visibility: VisibilityIcon,
    visibilityOff: VisibilityOffIcon,
    fileDownload: FileDownloadIcon,
    logout: LogoutIcon,
    lock: LockIcon,
    close: CloseIcon,
    output: OutputIcon,
    peopleAlt: PeopleAltIcon,
    precisionManufacturing: PrecisionManufacturingIcon,
    phonelinkErase: PhonelinkEraseIcon,
    resetTv: ResetTvIcon,
    addToHomeScreen: AddToHomeScreenIcon,
    verticalAlignTop: VerticalAlignTopIcon,
    verticalAlignBottom: VerticalAlignBottomIcon,
    palette: PaletteIcon,
    starSharp: StarSharpIcon,
    arrowLeftSharp: ArrowLeftSharpIcon,
    arrowRightSharp: ArrowRightSharpIcon,
    locationOnSharp: LocationOnSharpIcon,
    infoSharp: InfoSharpIcon,
    keyboardArrowDownSharp: KeyboardArrowDownSharpIcon,
    keyboardArrowRightSharp: KeyboardArrowRightSharpIcon,
    help: HelpIcon,
    login: LoginIcon,
    badge: BadgeIcon,
    pictureAsPdf: PictureAsPdfIcon,
    email: EmailIcon,
    searchOff: SearchOffIcon,
    doNotDisturb: DoNotDisturbIcon,
    image: ImageIcon,
    autoMode: AutoModeIcon,
    lockReset: LockResetIcon,
    playListAddCircle: PlaylistAddCircleIcon,
    today: TodayIcon,
    calendarToday: CalendarTodayIcon,
    chevronRight: ChevronRightIcon,
    viewSideBar: ViewSidebarIcon,
    localGasStation: LocalGasStationIcon,
    editCalendar: EditCalendarIcon,
    summarize: SummarizeIcon,
    airportShuttle: AirportShuttleIcon,
    construction: ConstructionIcon,
    adminPanelSettings: AdminPanelSettingsIcon,
    business: BusinessIcon,
    analytics: AnalyticsIcon,
    devicesFold: DevicesFoldIcon,
    sendTimeExtension: SendTimeExtensionIcon,
    plagiarism: PlagiarismIcon,
    equalizer: EqualizerIcon,
    preview: PreviewIcon,
    euro: EuroIcon,
    freeCancellation: FreeCancellationIcon,
    done: DoneIcon,
    doneAll: DoneAllIcon,
    publishedWithChanges: PublishedWithChangesIcon,
    send: SendIcon,
    monetizationOn: MonetizationOnIcon,
    restartAlt: RestartAltIcon,
    wifiOff: WifiOffIcon,
    contentCopy: ContentCopyIcon,
    settings: SettingsIcon,
    addRoad: AddRoadIcon,
    editRoad: EditRoadIcon,
    removeRoad: RemoveRoadIcon,
    tableChart: TableChartIcon,
    event: EventIcon,
    smartButton: SmartButtonIcon,
    editNote: EditNoteIcon,
    spaceDashboard: SpaceDashboardIcon,
    public: PublicIcon,
    personOff: PersonOffIcon,
    person: PersonIcon,
    scale: ScaleIcon,
    lightMode: LightModeIcon,
    darkMode: DarkModeIcon
};

export interface IconProps {
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    classes?: { iconButton?: string; icon?: string };
    title?: string;
    name: keyof typeof iconMap;
    color?: string;
    disabled?: boolean;
    onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement>;
    dark?: boolean;
    type?: 'button' | 'reset' | 'submit';
    loading?: boolean;
    iconStyle?: React.CSSProperties;
    iconButtonStyle?: React.CSSProperties;
    tabIndex?: number;
}

const Icon: React.FC<IconProps> = ({
    onClick = () => {},
    classes = {},
    title = '',
    name,
    color = '',
    disabled = false,
    onKeyDown = () => {},
    dark = false,
    type = 'button',
    loading = false,
    iconStyle,
    iconButtonStyle,
    tabIndex,
}) => {
    const IconComponent = iconMap[name];

    const iconColor = disabled ? (dark ? 'gray' : 'lightgray') : color || (dark ? 'white' : 'black');
    const hoverColor = disabled ? (dark ? 'gray' : 'lightgray') : dark ? '#b3b3b3' : '#333';

    return (
        <IconButton
            onClick={onClick}
            className={'pad-0-imp ' + classes?.iconButton}
            title={title}
            disabled={disabled || loading}
            onKeyDown={onKeyDown}
            style={{ color: iconColor, ...iconButtonStyle }}
            type={type}
            tabIndex={tabIndex}
        >
            {loading ? (
                <CircularProgress size={23} color="inherit" />
            ) : (
                <IconComponent
                    fontSize="medium"
                    classes={{ root: classes.icon }}
                    style={{  transition: 'color 0.3s', ...iconStyle }}
                    onMouseEnter={(e) => {
                        if (!disabled) e.currentTarget.style.color = hoverColor;
                    }}
                    onMouseLeave={(e) => {
                        if (!disabled) e.currentTarget.style.color = iconColor;
                    }}
                />
            )}
        </IconButton>
    );
};

export default Icon;
